import { Alert, Checkbox as MuiCheckBox, CheckboxProps, FormControl, FormControlLabel } from "@mui/material";
import { useField } from "@unform/core";
import { useEffect, useMemo, useState } from "react";
import { UtilidadeService } from "../../services/api/utilidades/UtilidadesService";

type ICheckBoxProps = CheckboxProps &{
    isExternalLoading: boolean;
    name: string;
    label: string;
    required?: boolean;
    checked: boolean;
    labelPlacement?: "end" | "start" | "top" | "bottom" | undefined;
}

export const CheckBox: React.FC<ICheckBoxProps> = ({ isExternalLoading = false, name, label,required = false, checked,labelPlacement, ...rest }) => {
    const { fieldName, registerField, defaultValue, error, clearError } = useField(name)

    const [value, setValue] = useState(defaultValue || false);

    useEffect(() => {

        if(fieldName === "ativo"){
            setValue(true);
        }

        registerField({
            name: fieldName,
            getValue: () => value,
            setValue: (_, newSelectdId) => setValue(newSelectdId),
        })
    }, [registerField, fieldName, value])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {          
        
        setValue(event.target.checked);
    }

    return (
        <FormControl disabled={isExternalLoading} required={required}>
            <FormControlLabel
                control={
                    <MuiCheckBox
                        {...rest}
                        required={required}
                        name={fieldName}
                        checked={checked}      
                        value={value}                  
                        onChange={(e) => {handleChange(e); rest.onChange?.(e, false);}}
                        sx={{
                            '& .MuiFormControlLabel-label': { 
                                fontSize: UtilidadeService.isMobile() ? 14 : 18 
                            },
                            '& .MuiSvgIcon-root': {
                                fontSize: UtilidadeService.isMobile() ? 20 : 28,
                            },
                        }}
                    />
                }
                label={label}
                labelPlacement={labelPlacement}
            />
        </FormControl>
    )
};